import { helper } from '@ember/component/helper';

import { fnxHelper } from 'rise-ui/helpers/fnx.js';

export default helper(function eventHelper(positional, hash) {
  return fnxHelper(positional, { ...hash, value: 'target.value' });
});
